import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  title: {
    paddingBottom: theme.spacing(3),
    textTransform: 'uppercase',
    color: theme.palette.action.main,
  },
  paragraph: {
    paddingBottom: theme.spacing(3),
  },
  // El `Link` de MUI usa `color="primary"`, que en este tema es casi negro
  // (#0b1015), y `underline="hover"`. Así los enlaces se ven igual que el texto
  // de alrededor, por eso se forzan el acento y el subrayado permanente.
  link: {
    color: theme.palette.action.main,
    textDecoration: 'underline',
    fontWeight: 500,
    '&:hover': {
      color: theme.palette.action.light,
    },
  },
  divider: {
    height: 1,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    backgroundColor: theme.palette.action.main,
  },
}));
